module.exports = __webpack_public_path__ + "img/1.9e36f3f4.jpg";